import * as React from "react";
import {
    IAssetAllocationComparison,
    IBuildingBlockComparison,
    ILiquidityProfileComparison,
    IModelPortfolioComparison,
    IPortfolio
} from "../../api/PortfolioApi";
import {getPortfolioComparison} from "./portfolioUtil";
import {formatDate} from "../../utils/dateUtil";

export interface IPortfoliosComparisonProps {
    currentPlanPortfolio: IPortfolio;
    modelPortfolio: IPortfolio;
    asOfDate: string;
}
export const PortfolioComparison: React.FunctionComponent<IPortfoliosComparisonProps> = (props: IPortfoliosComparisonProps) => {
    const getValidValue = (value: number | null): string => {
        return value !== null ? `${value.toString()}%` : " --- ";
    };
    const renderPortfolioComparisonTable = (modelPortfolioComparison: IModelPortfolioComparison) => {
        const [day, month, year] = props.asOfDate.split("/").map(Number);

        return <div className="portfolio-comparison__table-container"
                    data-testid="portfolio-comparison__table-container">
            <table className="portfolio-comparison__table" data-testid={"portfolio-comparison__table"}>
                <thead>
                <tr>
                    <th className="portfolio-comparison__table-header-title left"/>
                    <th className="portfolio-comparison__table-header-model right"
                        data-testid="portfolio-comparison__table-header-model">
                        Model Portfolio
                        <div>{props.modelPortfolio.name}</div>
                    </th>
                    <th className="portfolio-comparison__table-header-current right"
                        data-testid="portfolio-comparison__table-header-current">
                        {props.currentPlanPortfolio.name}
                        <div className="portfolio-comparison__asOfDate" data-testid="portfolio-comparison__asOfDate">
                            as of {formatDate(new Date(year, month - 1, day), "DD MMM YYYY")}
                        </div>
                    </th>
                </tr>
                </thead>
                {renderLiquidityProfiles(modelPortfolioComparison.liquidityProfiles)}
            </table>
        </div>;
    };

    const renderLiquidityProfiles = (liquidityProfileComparisons: ILiquidityProfileComparison[]) => {
        return liquidityProfileComparisons.map((liquidityProfileComparison: ILiquidityProfileComparison) => (
            <tbody key={liquidityProfileComparison.name} className="portfolio-comparison__table-body">
            <tr key={liquidityProfileComparison.name}>
                <td className="portfolio-comparison__table-liquidity-title left">{liquidityProfileComparison.name}</td>
                <td className="portfolio-comparison__table-liquidity-model-data right">
                    {getValidValue(liquidityProfileComparison.modelTotalPercentage)}
                </td>
                <td className="portfolio-comparison__table-liquidity-current-data right">
                    {getValidValue(liquidityProfileComparison.totalPercentage)}
                </td>
            </tr>
            {liquidityProfileComparison.buildingBlocks.map((buildingBlockComparison: IBuildingBlockComparison) => (
                <React.Fragment key={buildingBlockComparison.name}>
                    <tr>
                        <td className="portfolio-comparison__table-building-block-title left">{buildingBlockComparison.name}</td>
                        <td className="portfolio-comparison__table-building-block-model-data right">
                            {getValidValue(buildingBlockComparison.modelTotalPercentage)}
                        </td>
                        <td className="portfolio-comparison__table-building-block-current-data right">
                            {getValidValue(buildingBlockComparison.totalPercentage)}
                        </td>
                    </tr>
                    {buildingBlockComparison.assetAllocations
                        .map((assetAllocationComparison: IAssetAllocationComparison) => (
                        <tr key={assetAllocationComparison.assetClass}>
                            <td className="portfolio-comparison__table-asset-title left">{assetAllocationComparison.assetClass}</td>
                            <td className="portfolio-comparison__table-asset-model-data right">
                                {getValidValue(assetAllocationComparison.modelMarketValuePctOfTotal)}
                            </td>
                            <td className="portfolio-comparison__table-asset-current-data right">
                                {getValidValue(assetAllocationComparison.marketValuePctOfTotal)}
                            </td>
                        </tr>
                    ))}
                </React.Fragment>
            ))}
            </tbody>
        ));
    };
    return renderPortfolioComparisonTable(getPortfolioComparison(props.currentPlanPortfolio, props.modelPortfolio));
};